import axios from '@/components/common/resouces/http.js'
import global_ from '@/components/common/resouces/config'//引用模块进来
const state = {
  lang:''
}
const getter = {}

const mutations = {
   langEn (state, res) {
       state.lang = res
        window.localStorage.setItem('language', res);

    },
    langCn (state, res) {
       state.lang = res
       // console.log(res)       
       window.localStorage.setItem('language', res);

    },
}
const actions = {
    langEn(context){   //切换语言
        context.commit('langEn', 'en-us')  
    },
    langCn(context){   //切换语言
        context.commit('langCn', 'zh-cn')  
    }  
}
export default {
  state,
  getter,
  mutations,
  actions
}







// WEBPACK FOOTER //
// ./src/store/modules/lang.js